
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/candlestick-chart",
      function () {
        return require("private-next-pages/x/api/charts/candlestick-chart.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/candlestick-chart"])
      });
    }
  